import { __assign, __awaiter, __generator } from "tslib";
import { getNamedType, GraphQLList } from 'graphql';
import DataLoader from 'dataloader';
import { delegateToSchema } from '@graphql-tools/delegate';
import { relocatedError } from '@graphql-tools/utils';
var cache1 = new WeakMap();
function createBatchFn(options) {
    var _this = this;
    var _a;
    var argsFromKeys = (_a = options.argsFromKeys) !== null && _a !== void 0 ? _a : (function (keys) { return ({ ids: keys }); });
    var valuesFromResults = options.valuesFromResults, lazyOptionsFn = options.lazyOptionsFn;
    return function (keys) { return __awaiter(_this, void 0, void 0, function () {
        var results, values;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, delegateToSchema(__assign({ returnType: new GraphQLList(getNamedType(options.info.returnType)), onLocatedError: function (originalError) {
                            return relocatedError(originalError, originalError.path.slice(0, 0).concat(originalError.path.slice(2)));
                        }, args: argsFromKeys(keys) }, (lazyOptionsFn == null ? options : lazyOptionsFn(options))))];
                case 1:
                    results = _a.sent();
                    if (results instanceof Error) {
                        return [2 /*return*/, keys.map(function () { return results; })];
                    }
                    values = valuesFromResults == null ? results : valuesFromResults(results, keys);
                    return [2 /*return*/, Array.isArray(values) ? values : keys.map(function () { return values; })];
            }
        });
    }); };
}
export function getLoader(options) {
    var _a;
    var fieldName = (_a = options.fieldName) !== null && _a !== void 0 ? _a : options.info.fieldName;
    var cache2 = cache1.get(options.info.fieldNodes);
    if (cache2 === undefined) {
        cache2 = new WeakMap();
        cache1.set(options.info.fieldNodes, cache2);
        var loaders_1 = Object.create(null);
        cache2.set(options.schema, loaders_1);
        var batchFn_1 = createBatchFn(options);
        var loader_1 = new DataLoader(function (keys) { return batchFn_1(keys); }, options.dataLoaderOptions);
        loaders_1[fieldName] = loader_1;
        return loader_1;
    }
    var loaders = cache2.get(options.schema);
    if (loaders === undefined) {
        loaders = Object.create(null);
        cache2.set(options.schema, loaders);
        var batchFn_2 = createBatchFn(options);
        var loader_2 = new DataLoader(function (keys) { return batchFn_2(keys); }, options.dataLoaderOptions);
        loaders[fieldName] = loader_2;
        return loader_2;
    }
    var loader = loaders[fieldName];
    if (loader === undefined) {
        var batchFn_3 = createBatchFn(options);
        loader = new DataLoader(function (keys) { return batchFn_3(keys); }, options.dataLoaderOptions);
        loaders[fieldName] = loader;
    }
    return loader;
}
//# sourceMappingURL=getLoader.js.map